import { PlanNames } from '../../planNames';
export const stripePriceToPlanMap = {
    'price_1NpVJgDI1wNTHxdhzAfKNcTR': PlanNames.Professional,
};
//# sourceMappingURL=july2023.js.map